/// <reference path="../../_ext/Editors/BOMEditorDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class OpeningStockItemsBOMDialog extends _Ext.BOMEditorDialog<OpeningStockItemsBOMRow> { 
        protected getLocalTextPrefix() { return OpeningStockItemsBOMRow.localTextPrefix; } 

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        constructor() {
            super();
            q.setTextRightAlign(this.form.Pieces); 
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.PointerWeight);
            q.setTextRightAlign(this.form.BomAmount);
            q.setTextRightAlign(this.form.BomRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.Purity);

            // Module Configuration
            this.UseKaratWiseRate = q.ToBool(TabAurous.GetConfigValue(1014));

            this.form.BomRate.changeSelect2(e => {
                var calcon = this.form.CalcOnId.value;
                if (calcon == "4" || calcon == "5")
                    if (this.form.ItemTypeId.value == 104) {
                        if (this.UseKaratWiseRate == true)
                            this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value || 0;
                        else
                            this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value * this.form.Purity.value || 0;
                    }
                    else {
                        this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value;
                    }
                if (calcon == "3")
                    this.form.BomAmount.value = this.form.BomRate.value * this.form.Pieces.value;

                //this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;

            });

            this.form.BOMProductId.changeSelect2(e => {
                var ItemID = Q.toId(this.form.ItemTypeId.value);
                if (ItemID == null) {
                    Q.notifyWarning("Select Item Type")
                    this.form.BOMProductId.value = "";
                    this.form.ItemTypeId.element.attr("tabindex", 1);
                }
                else {

                    var productID = Q.toId(this.form.BOMProductId.value);
                    
                    var Component: OMS.RawMaterialMasterRow;

                    OMS.RawMaterialMasterService.Retrieve({ EntityId: productID }, response => Component = response.Entity, { async: false });

                    this.form.ProductCode.value = Component.ProductCode;
                    this.form.Weight.value = 0;
                    this.form.Pieces.value = 0;

                    if (Component != null) {
                        this.IsConfigurable = Component.IsConfigurable;
                        this.form.CategoryId.value = Component.CategoryId.toString();
                        this.form.SubCategoryId.value = Component.SubCategoryId.toString();
                        this.form.ProductTypeId.value = Component.ProductTypeId.toString();
                        this.form.ItemType.value = Component.ItemType;
                        this.form.CalcOnId.value = Component.CalcOnId.toString();
                        this.entity.CostMethodId = Component.CostMethodId;

                        if (this.form.ItemTypeId.value == 104) {
                            var std = Component.Purity;
                            this.form.Purity.value = std;
                            this.form.MetalColorId.value = Component.MetalColorId.toString();
                            this.form.KaratId.value = Component.KaratId.toString();
                            this.form.ItemType.value = Component.ItemType;
                        }

                        if (this.form.ItemTypeId.value == 105) {
                            this.form.ShapeId.value = Component.ShapeId.toString();
                            this.form.StoneColorId.value = Component.StoneColorId.toString();
                            this.form.QualityId.value = Component.QualityId.toString();
                            this.form.SieveId.value = Component.SieveId.toString();
                            this.form.GroupSieveId.value = Component.GroupSieveId.toString();
                            this.form.StoneSizeId.value = Component.StoneSizeId.toString();
                            this.form.StoneCutId.value = Component.StoneCutId.toString();
                            this.form.StoneCuletId.value = Component.StoneCuletId.toString();
                            this.form.StoneFluorescenceId.value = Component.StoneFluorescenceId.toString();
                            this.form.StoneGirdleId.value = Component.StoneGirdleId.toString();
                            this.form.StonePolishId.value = Component.StonePolishId.toString();
                            this.form.StoneSymmetryId.value = Component.StoneSymmetryId.toString();
                            this.form.StoneTable.value = Component.StoneTable;
                            this.form.StoneDepth.value = Component.StoneDepth;
                            this.form.ItemType.value = Component.ItemType;
                        }
                        ItemFieldHelper.PurchaseBOMFields(this);
                        this.GetRate();
                    }
                }

            });

            this.form.Pieces.changeSelect2(e => {
                if (this.form.CalcOnId.value == "3") {
                    this.form.BomAmount.value = this.form.Pieces.value * this.form.BomRate.value;
                    //this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;
                }
            });

            this.form.Weight.changeSelect2(e => {
                if (this.form.CalcOnId.value == "4" || this.form.CalcOnId.value == "5")
                    if (this.form.Purity.value > 0) {
                        this.form.BomAmount.value = this.form.Weight.value * this.form.BomRate.value * this.form.Purity.value;
                        this.form.PureWeight.value = this.form.Weight.value * this.form.Purity.value;
                    }
                    else {
                        this.form.BomAmount.value = this.form.Weight.value * this.form.BomRate.value
                    }
                //this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;

            });

            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.BOMProductId.cascadeField = "ProductTypeId";
                    this.form.BOMProductId.cascadeValue = this.form.ProductTypeId.value;

                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.value = "";
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    ItemFieldHelper.PurchaseBOMFields(this);
                }
            });


            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
                ItemFieldHelper.PurchaseBOMFields(this);
            })

            //this.form.GrossWeight.changeSelect2(e => {
            //    var wt = (this.parentEditor.parentDialog as OpeningStockItemsDialog).form.Weight.value;
            //    this.form.Weight.value = this.form.GrossWeight.value - wt;
            //    if (this.form.CalcOnId.value == "4" || this.form.CalcOnId.value == "5")
            //        if (this.form.Purity.value > 0) {
            //            this.form.PureWeight.value = this.form.Weight.value * this.form.Purity.value;
            //            this.form.BomAmount.value = this.UseKaratWiseRate == 'True' ? this.form.BomRate.value * this.form.Weight.value : this.form.BomRate.value * this.form.PureWeight.value;
            //        }
            //        else {
            //            this.form.BomAmount.value = this.form.Weight.value * this.form.BomRate.value
            //        }
            //})

            // Validate Purity
            this.form.Purity.change(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                if (KaratId != null) {
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    var min = purity.MinPurity;
                    var max = purity.MaxPurity;
                    var std = purity.StdPurity;
                    var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                        this.form.Purity.value = std;
                    }
                }
            });

            this.form.ItemTypeId.changeSelect2(e => {
                ItemFieldHelper.PurchaseBOMFields(this);
            });

            this.form.StoneSizeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.ShapeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.SieveId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.QualityId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.StoneColorId.changeSelect2(e => {
                this.GetRate();
            });
        }

        GetRate() {
            var calcon = this.form.CalcOnId.value;
            this.RateListId = (this.parentEditor.parentDialog as OpeningStockItemsDialog).RateListId;

            if (this.form.ItemTypeId.value == 105) {
                var rateatb: RateHelper.RateAttributes = {
                    ProductTypeId: parseInt(this.form.ProductTypeId.value),
                    CategoryId: parseInt(this.form.CategoryId.value),
                    SubCategoryId: parseInt(this.form.SubCategoryId.value),
                    ShapeId: parseInt(this.form.ShapeId.value),
                    SieveId: parseInt(this.form.SieveId.value),
                    GroupSieveId: parseInt(this.form.GroupSieveId.value),
                    StoneSizeId: parseInt(this.form.StoneSizeId.value),
                    StoneColorId: parseInt(this.form.StoneColorId.value),
                    QualityId: parseInt(this.form.QualityId.value),
                    RateListId: this.RateListId,
                    ProductId: parseInt(this.form.BOMProductId.value),
                    CostMethodId: this.entity.CostMethodId,
                    Weight: this.form.Weight.value
                }
                this.form.BomRate.value = RateHelper.GetStonePurchaseRatenoAtb(rateatb);

                this.form.BomRate.value = this.form.BomRate.value / this.ExchangeRate;

                if (calcon == "4" || calcon == "5")
                    this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value;
                if (calcon == "3")
                    this.form.BomAmount.value = this.form.BomRate.value * this.form.Pieces.value;
            }
            else if (this.form.ItemTypeId.value == 104) {
                this.form.BomRate.value = RateHelper.GetMetalRate(parseInt(this.form.ProductTypeId.value), parseInt(this.form.KaratId.value), false, new Date());
                let UseKaratRate = q.ToBool(TabAurous.GetConfigValue(1021)); 

                this.form.BomRate.value = this.form.BomRate.value / this.ExchangeRate;
                if (calcon == "4" || calcon == "5")
                    this.form.BomAmount.value = UseKaratRate == true ? this.form.BomRate.value * this.form.Weight.value : this.form.BomRate.value * this.form.Weight.value * this.form.Purity.value

                if (calcon == "3")
                    this.form.BomAmount.value = this.form.BomRate.value * this.form.Pieces.value;
            }

            //this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;
        }

        afterLoadEntity() {
            super.afterLoadEntity();

            this.BOMMaster = (this.parentEditor.parentDialog as OpeningStockItemsDialog);
            this.RateListId = this.BOMMaster.RateListId;
            this.LaborListId = this.BOMMaster.LaborListId;
            this.StoneMarkup = this.BOMMaster.StoneMarkup;
            this.StoneDiscount = this.BOMMaster.StoneDiscount;
            this.ExchangeRate = this.BOMMaster.ExchangeRate;
            this.TransDate = this.BOMMaster.TransDate;

            var Component: OMS.RawMaterialMasterRow;
            if (!Q.isEmptyOrNull(this.form.BOMProductId.value)) {
                OMS.RawMaterialMasterService.Retrieve({ EntityId: this.form.BOMProductId.value }, response => Component = response.Entity, { async: false });
                this.IsConfigurable = Component.IsConfigurable;
            }


            ItemFieldHelper.PurchaseBOMFields(this);
            if (this.BOMMaster.isReadOnly) {
                this.setReadOnly(true);
            }

        }

        //protected setFields() {

        //    switch (this.form.ItemTypeId.value) {

        //        case 105: {
        //            q.hideField(this.form.KaratId);
        //            q.hideField(this.form.Purity);
        //            q.hideField(this.form.MetalColorId);
        //            q.hideField(this.form.Purity);
        //            q.hideField(this.form.PureWeight);
        //            //q.hideField(this.form.GrossWeight);
        //            q.showAndSetRequiredField(this.form.ShapeId);q.showAndSetRequiredField(this.form.Pieces);
        //            q.showAndSetRequiredField(this.form.QualityId);
        //            q.showAndSetRequiredField(this.form.StoneColorId);
        //            q.showAndSetRequiredField(this.form.StoneSizeId);
        //            q.showAndSetRequiredField(this.form.SieveId);
        //            q.showAndDisableField(this.form.CategoryId);
        //            q.showAndSetRequiredField(this.form.SubCategoryId);
        //            q.showAndSetRequiredField(this.form.SettingId);
        //            Serenity.EditorUtils.setRequired(this.form.Pieces, true);
        //            Serenity.EditorUtils.setReadOnly(this.form.ShapeId, true);
        //            var prdbomid = "";
        //            if (this.form.BOMProductId.value != "")
        //                prdbomid = this.form.BOMProductId.value;
        //            this.form.BOMProductId.cascadeField = "ItemTypeId";
        //            this.form.BOMProductId.cascadeValue = this.form.ItemTypeId.value;

        //            this.form.BOMProductId.value = prdbomid;
        //            switch (parseInt(this.form.CategoryId.value)) {
        //                case 1:
        //                case 3:
        //                case 4:
        //                    q.hideField(this.form.StoneCutId);
        //                    q.hideField(this.form.StonePolishId);
        //                    q.hideField(this.form.StoneSymmetryId);
        //                    q.hideField(this.form.StoneFluorescenceId);
        //                    q.hideField(this.form.StoneCuletId);
        //                    q.hideField(this.form.StoneGirdleId);
        //                    q.hideField(this.form.StoneTable);
        //                    q.hideField(this.form.StoneDepth);
        //                    q.hideField(this.form.CertificateNo);
        //                    //q.hideEditorCategory(this.form.StoneCuletId);
        //                    break;
        //                case 2:
        //                    q.showAndSetRequiredField(this.form.StoneCutId);
        //                    q.showAndSetRequiredField(this.form.StonePolishId);
        //                    q.showAndSetRequiredField(this.form.StoneSymmetryId);
        //                    q.showAndSetRequiredField(this.form.StoneFluorescenceId);
        //                    q.showAndSetRequiredField(this.form.StoneCuletId);
        //                    q.showAndSetRequiredField(this.form.StoneGirdleId);
        //                    q.showAndSetRequiredField(this.form.StoneTable);
        //                    q.showAndSetRequiredField(this.form.StoneDepth);
        //                    q.showAndSetRequiredField(this.form.CertificateNo);
        //                    q.showAndSetRequiredField(this.form.Pieces);
        //                    q.showAndSetRequiredField(this.form.Weight);
        //                    //q.showAndSetRequiredField(this.form.Lab);

        //                    break;
        //                default:
        //                    q.hideField(this.form.StoneCutId);
        //                    q.hideField(this.form.StonePolishId);
        //                    q.hideField(this.form.StoneSymmetryId);
        //                    q.hideField(this.form.StoneFluorescenceId);
        //                    q.hideField(this.form.StoneCuletId);
        //                    q.hideField(this.form.StoneGirdleId);
        //                    q.hideField(this.form.StoneTable);
        //                    q.hideField(this.form.StoneDepth);
        //                    q.hideField(this.form.CertificateNo);
        //                    break;

        //            }

        //            break;
        //        }
        //        case 104: {
        //            q.showAndSetRequiredField(this.form.KaratId);
        //            q.showAndDisableField(this.form.MetalColorId);
        //            q.showAndDisableField(this.form.KaratId);
        //            q.showAndSetRequiredField(this.form.Purity);
        //            q.showAndDisableField(this.form.PureWeight);
        //            //q.showAndEnableField(this.form.GrossWeight);

        //            q.hideField(this.form.ShapeId);
        //            q.hideField(this.form.QualityId);
        //            q.hideField(this.form.StoneColorId);
        //            q.hideField(this.form.StoneSizeId);
        //            q.hideField(this.form.SieveId);
        //            q.hideField(this.form.Pieces);
        //            q.hideField(this.form.CategoryId);
        //            q.hideField(this.form.SubCategoryId);
        //            q.hideField(this.form.CertificateNo);
        //            q.hideField(this.form.SettingId);

        //            var prdbomid = "";
        //            if (this.form.BOMProductId.value != "")
        //                prdbomid = this.form.BOMProductId.value;
        //            this.form.BOMProductId.cascadeField = "ItemTypeId";
        //            this.form.BOMProductId.cascadeValue = this.form.ItemTypeId.value;
        //            this.form.BOMProductId.value = prdbomid;
        //            break;
        //        }

        //        default: {
        //            q.hideField(this.form.KaratId);
        //            q.hideField(this.form.Purity);
        //            q.hideField(this.form.MetalColorId);
        //            q.hideField(this.form.ShapeId);
        //            q.hideField(this.form.QualityId);
        //            q.hideField(this.form.StoneColorId);
        //            q.hideField(this.form.StoneSizeId);
        //            q.hideField(this.form.SieveId);
        //            Serenity.EditorUtils.setRequired(this.form.Pieces, false);
        //            this.form.BOMProductId.value = "";
        //            this.form.BOMProductId.cascadeField = "ItemTypeId";
        //            this.form.BOMProductId.cascadeValue = this.form.ItemTypeId.value;
        //            break;
        //        }
        //    }
        //}

        protected validateBeforeSave() {

            if (this.form.ItemTypeId.value == 104) {
                OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    MetalColorId: Q.parseInteger(this.form.MetalColorId.value),
                    KaratId: Q.parseInteger(this.form.KaratId.value)
                },
                    response => {
                        this.form.BOMAttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );
            }

            if (this.form.ItemTypeId.value == 105) {
                OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    ShapeId: Q.parseInteger(this.form.ShapeId.value),
                    QualityId: Q.parseInteger(this.form.QualityId.value),
                    StoneSizeId: Q.parseInteger(this.form.StoneSizeId.value),
                    SieveId: Q.parseInteger(this.form.SieveId.value),
                    GroupSieveId: Q.parseInteger(this.form.GroupSieveId.value),
                    StoneColorId: Q.parseInteger(this.form.StoneColorId.value),
                    StoneCutId: Q.parseInteger(this.form.StoneCutId.value),
                    StonePolishId: Q.parseInteger(this.form.StonePolishId.value),
                    StoneSymmetryId: Q.parseInteger(this.form.StoneSymmetryId.value),
                    StoneFluorescenceId: Q.parseInteger(this.form.StoneFluorescenceId.value),
                    StoneCuletId: Q.parseInteger(this.form.StoneCuletId.value),
                    StoneGirdleId: Q.parseInteger(this.form.StoneGirdleId.value),
                    StoneTable: this.form.StoneTable.value,
                    StoneDepth: this.form.StoneDepth.value
                },
                    response => {
                        this.form.BOMAttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );
            }


            if (this.entity.RefTransBomId == null) {
                this.entity.RefTransBomId = 0
            }
            return true;
        }
    }
}